module.exports = (__webpack_require__(0))(402);


//////////////////
// WEBPACK FOOTER
// delegated ./src/stylesheets/widgets/metadataWidget.styl from dll-reference girder_lib
// module id = 222
// module chunks = 0